import ko from '@tko/build.knockout';
import $ from 'jquery';
import _ from 'lodash';

    

    var instance = null;

    /******  EndpointsCommonSingleton  ******/
    function EndpointsCommonSingleton() {
        if (instance !== null) {
            throw new Error('Cannot instanciate more than one EndpointsCommonSingleton, use EndpointsCommonSingleton.geInstance()');
        }
    }

    EndpointsCommonSingleton.prototype = {
        tagsRawToToken: function(rawTags) {
            if (_.isEmpty(rawTags) || !_.isString(rawTags)) {
                return [];
            }

            return _.chain(rawTags.split(',')).filter(Boolean).map(function(tagText) {
                tagText = tagText.trim();

                return {
                    label: tagText,
                    value: tagText
                };
            }).value();
        },
        tagsTokenToArray: function(tagTokens) {
            return _.map(tagTokens, 'label');
        },
        tagsTokenToRaw: function(tagTokens) {
            return this.tagsTokenToArray(tagTokens).join(',');
        },
        tagsRawToDisplay: function(rawTags) {
            return (_.isEmpty(rawTags) || !_.isString(rawTags)) ? '' : rawTags.replace(/(\w),(\w)/g, '$1, $2');
        },
        tagsDisplayToRaw: function(displayTags) {
            return (_.isEmpty(displayTags) || !_.isString(displayTags)) ? null : displayTags.replace(/(\w),\s+(\w)/g, '$1,$2');
        }
    };

    EndpointsCommonSingleton.getInstance = function() {
        if (instance === null) {
            instance = new EndpointsCommonSingleton();
        }
        return instance;
    };

    export default EndpointsCommonSingleton.getInstance();

